<template>
    <div
        class="tw-flex tw-flex-col-reverse md:tw-flex-row md:tw-gap-4 tw-bg-red-300 tw-rounded-md tw-p-2 tw-px-6 tw-items-center"
    >
        <!-- TrustBox widget - Mini -->
        <div class="trustpilot-widget tw-w-fit tw-mr-auto sm:tw-ml-auto" data-locale="de-DE" data-template-id="53aa8807dec7e10d38f59f32" data-businessunit-id="6249a28d40123731d8da3c4e" data-style-height="100" data-style-width="160">
            <a href="https://de.trustpilot.com/review/wedesigntrips.com" target="_blank" rel="noopener">Trustpilot</a>
        </div>
        <!-- End TrustBox widget -->
        <div
            class="tw-content-center"
        >
            <span>
                <slot />
            </span>
        </div>
    </div>
</template>

<script>

    export default {
        name: "TrustpilotRating",
    }
</script>

<style scoped>
</style>